// resolveMediaAspectRatio.js

/**
 * resolveMediaAspectRatio
 *
 * Resolves a usable aspect ratio from media node metadata.
 *
 * @param {object|null|undefined} node - Photo or video node.
 * @param {number} [fallback=1] - Ratio used when metadata is missing.
 *
 * @returns {number} Width/height ratio greater than zero.
 */
const resolveMediaAspectRatio = (node, fallback = 1) => {
    const width = Number(node?.width);
    const height = Number(node?.height);
    if (Number.isFinite(width) && Number.isFinite(height) && width > 0 && height > 0) {
        return width / height;
    }

    const ratio = Number(node?.aspectRatio);
    if (Number.isFinite(ratio) && ratio > 0) {
        return ratio;
    }

    return fallback;
};

export default resolveMediaAspectRatio;
